module.exports = __webpack_public_path__ + "static/fonts/Sarabun-Regular.5b8c217.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Sarabun-Regular.ttf
// module id = el36
// module chunks = 8